/**
 * Custom error class for user input validation errors.
 * These errors should not be reported to error monitoring services like Datadog
 * as they represent expected user input issues, not system errors.
 */
export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
    
    // Maintains proper stack trace for where our error was thrown (only works on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
}